import dayjs from 'dayjs';
export var MERIDIEM_TYPE = {
  AM: 1,
  PM: 2,
  NONE: -1
};
export var LOCALIZED_FORMAT = {
  L: 'MM/DD/YYYY',
  l: 'M/D/YYYY'
};
var TIMEPICKER_VALUE_LABEL_MAP_HOURS_12 = new Map();
var TIMEPICKER_LABEL_VALUE_MAP_HOURS_12 = new Map();
var TIMEPICKER_VALUE_LABEL_MAP_HOURS_24 = new Map();
var TIMEPICKER_LABEL_VALUE_MAP_HOURS_24 = new Map();
var TIMEPICKER_VALUE_LABEL_MAP_MINUTES = new Map();
var TIMEPICKER_LABEL_VALUE_MAP_MINUTES = new Map();
var TIMEPICKER_VALUE_LABEL_MAP_MERIDIEM = new Map();
var TIMEPICKER_LABEL_VALUE_MAP_MERIDIEM = new Map();
TIMEPICKER_VALUE_LABEL_MAP_MERIDIEM.set(MERIDIEM_TYPE.PM, 'PM');
TIMEPICKER_VALUE_LABEL_MAP_MERIDIEM.set(MERIDIEM_TYPE.AM, 'AM');
TIMEPICKER_VALUE_LABEL_MAP_MERIDIEM.set(MERIDIEM_TYPE.NONE, '');
TIMEPICKER_LABEL_VALUE_MAP_MERIDIEM.set('PM', MERIDIEM_TYPE.PM);
TIMEPICKER_LABEL_VALUE_MAP_MERIDIEM.set('AM', MERIDIEM_TYPE.AM);
TIMEPICKER_LABEL_VALUE_MAP_MERIDIEM.set('', MERIDIEM_TYPE.NONE);
for (var i = 0; i < 60; i++) {
  TIMEPICKER_LABEL_VALUE_MAP_MINUTES.set(String(i), i);
  if (i < 10) {
    TIMEPICKER_VALUE_LABEL_MAP_MINUTES.set(i, '0' + String(i));
    TIMEPICKER_LABEL_VALUE_MAP_MINUTES.set('0' + String(i), i);
  } else {
    TIMEPICKER_VALUE_LABEL_MAP_MINUTES.set(i, String(i));
  }
}
for (var _i = 1; _i <= 12; _i++) {
  TIMEPICKER_LABEL_VALUE_MAP_HOURS_12.set(String(_i), _i);
  if (_i < 10) {
    TIMEPICKER_VALUE_LABEL_MAP_HOURS_12.set(_i, '0' + String(_i));
    TIMEPICKER_LABEL_VALUE_MAP_HOURS_12.set('0' + String(_i), _i);
  } else {
    TIMEPICKER_VALUE_LABEL_MAP_HOURS_12.set(_i, String(_i));
  }
}
TIMEPICKER_VALUE_LABEL_MAP_HOURS_12.set(0, '12');
for (var _i2 = 0; _i2 < 24; _i2++) {
  TIMEPICKER_VALUE_LABEL_MAP_HOURS_24.set(_i2, String(_i2));
  if (_i2 < 10) {
    TIMEPICKER_VALUE_LABEL_MAP_HOURS_24.set(_i2, '0' + String(_i2));
    TIMEPICKER_LABEL_VALUE_MAP_HOURS_24.set('0' + String(_i2), _i2);
  } else {
    TIMEPICKER_VALUE_LABEL_MAP_HOURS_24.set(_i2, String(_i2));
  }
}
var TIME_VALUE_INTERVAL_MAP = new Map();
TIME_VALUE_INTERVAL_MAP.set('hour-12', [0, 12]);
TIME_VALUE_INTERVAL_MAP.set('hour-24', [0, 23]);
TIME_VALUE_INTERVAL_MAP.set('minute', [0, 59]);
var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var VIEWS = {
  YEAR: 'year',
  MONTH: 'month',
  DECADE: 'decade'
};
var UNITS = {
  YEAR: 'year',
  MONTH: 'month',
  DECADE: 'decade'
};
var MONTHTABLE = {
  Jan: 0,
  Feb: 1,
  Mar: 2,
  Apr: 3,
  May: 4,
  Jun: 5,
  Jul: 6,
  Aug: 7,
  Sep: 8,
  Oct: 9,
  Nov: 10,
  Dec: 11
};
var WEEKS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var DATETABLE_CONSTANT = {
  NUMS_OF_COLUMNS: 7,
  NUMS_OF_ROWS: 6
};
var DAYS_IN_WEEK = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6
};
var HOURS = ['12', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11'];
var MINUTES = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];
var RANGE_SCALES = {
  TODAY: 'Today',
  YESTERDAY: 'Yesterday',
  LAST_7_DAYS: 'Last 7 days',
  LAST_30_DAYS: 'Last 30 days',
  THIS_MONTH: 'This month',
  LAST_MONTH: 'Last month',
  CUSTOM_RANGE: 'Custom range'
};
export var DetailToGranularityMap = new Map();
DetailToGranularityMap.set('month', 'day');
DetailToGranularityMap.set('year', 'month');
DetailToGranularityMap.set('decade', 'year');
var DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
var CALENDAR_POSITION = {
  LEFT: 0,
  RIGHT: 1
};
var DEFAULT_RANGE_MENU = [{
  name: RANGE_SCALES.TODAY,
  dates: [dayjs().startOf('day').toDate(), dayjs().endOf('day').toDate()]
}, {
  name: RANGE_SCALES.YESTERDAY,
  dates: [dayjs().subtract(1, 'day').startOf('day').toDate(), dayjs().subtract(1, 'day').endOf('day').toDate()]
}, {
  name: RANGE_SCALES.LAST_7_DAYS,
  dates: [dayjs().subtract(6, 'day').startOf('day').toDate(), dayjs().endOf('day').toDate()]
}, {
  name: RANGE_SCALES.LAST_30_DAYS,
  dates: [dayjs().subtract(29, 'day').startOf('day').toDate(), dayjs().endOf('day').toDate()]
}, {
  name: RANGE_SCALES.THIS_MONTH,
  dates: [dayjs().startOf('month').toDate(), dayjs().endOf('month').toDate()]
}, {
  name: RANGE_SCALES.LAST_MONTH,
  dates: [dayjs().subtract(1, 'month').startOf('month').toDate(), dayjs().subtract(1, 'month').endOf('month').toDate()]
}];
var INPUT_ARIA_LABEL = {
  hasDisabledDays: '1 or more disabled day is selected in range',
  invalidDate: 'invalid date, review dates entered',
  invalidDateFormat: 'invalid date format, enter date in MM/DD/YYYY format'
};
export var TIME_PANEL = 'time_panel';
export var CALENDAR_PANEL = 'calendar_panel';
export var MONTH_BUTTON = 'month_button';
export var YEAR_BUTTON = 'year_button';
export var PREV_BUTTON = 'prev_button';
export var NEXT_BUTTON = 'next_button';
export var LEFT_MONTH_BUTTON = 'left_month_button';
export var LEFT_YEAR_BUTTON = 'left_year_button';
export var LEFT_CALENDAR_PANEL = 'left_calendar_panel';
export var RIGHT_MONTH_BUTTON = 'right_month_button';
export var RiGHT_YEAR_BUTTON = 'right_year_button';
export var RIGHT_PREV_BUTTON = 'right_prev_button';
export var RIGHT_NEXT_BUTTON = 'right_next_button';
export var PRIMARY_YEAR_VIEW_YEAR_BUTTON = 'primary_year_view_year_button';
export var SECONDARY_YEAR_VIEW_YEAR_BUTTON = 'secondary_year_view_year_button';
export var TIMETYPE = {
  HOUR: 'hour',
  MINUTE: 'minute',
  MERIDIEM: 'meridiem'
};
var DOUBLE_MONTH_ORDERS = [LEFT_MONTH_BUTTON, LEFT_YEAR_BUTTON, LEFT_CALENDAR_PANEL, RIGHT_MONTH_BUTTON, RiGHT_YEAR_BUTTON, RIGHT_PREV_BUTTON, RIGHT_NEXT_BUTTON];
var DOUBLE_YEAR_ORDERS = [LEFT_CALENDAR_PANEL, PRIMARY_YEAR_VIEW_YEAR_BUTTON, SECONDARY_YEAR_VIEW_YEAR_BUTTON, RIGHT_PREV_BUTTON, RIGHT_NEXT_BUTTON];
var DOUBLE_DECADE_ORDERS = [LEFT_CALENDAR_PANEL, RIGHT_PREV_BUTTON, RIGHT_NEXT_BUTTON];
var SINGLE_MONTH_ORDERS = [MONTH_BUTTON, YEAR_BUTTON, PREV_BUTTON, NEXT_BUTTON, CALENDAR_PANEL];
var SINGLE_YEAR_ORDERS = [PRIMARY_YEAR_VIEW_YEAR_BUTTON, PREV_BUTTON, NEXT_BUTTON, CALENDAR_PANEL];
var SINGLE_DECADE_ORDERS = [PREV_BUTTON, NEXT_BUTTON, CALENDAR_PANEL];
var FORMAT_GROUP = new Map();
FORMAT_GROUP.set('month-year', ['DD/MM/YYYY', 'MM/DD/YYYY', 'YYYY/MM/DD', 'YYYY/DD/MM']);
FORMAT_GROUP.set('month-decade', ['DD/MM/YYYY', 'MM/DD/YYYY', 'YYYY/MM/DD', 'YYYY/DD/MM']);
FORMAT_GROUP.set('year-decade', ['MM/YYYY', 'YYYY/MM']);
FORMAT_GROUP.set('decade-decade', ['YYYY']);
FORMAT_GROUP.set('year-year', ['MM/YYYY', 'YYYY/MM', 'MM']);
FORMAT_GROUP.set('month-month', ['DD/MM/YYYY', 'MM/DD/YYYY', 'YYYY/MM/DD', 'YYYY/DD/MM']);
export { FORMAT_GROUP, SINGLE_MONTH_ORDERS, SINGLE_YEAR_ORDERS, SINGLE_DECADE_ORDERS, DOUBLE_MONTH_ORDERS, DOUBLE_DECADE_ORDERS, DOUBLE_YEAR_ORDERS, INPUT_ARIA_LABEL, CALENDAR_POSITION, MONTHS, WEEKS, DATETABLE_CONSTANT, DAYS_IN_WEEK, MONTHTABLE, HOURS, RANGE_SCALES, MINUTES, DEFAULT_DATE_FORMAT, DEFAULT_RANGE_MENU, VIEWS, UNITS, TIMEPICKER_VALUE_LABEL_MAP_HOURS_12, TIMEPICKER_VALUE_LABEL_MAP_HOURS_24, TIMEPICKER_LABEL_VALUE_MAP_HOURS_12, TIMEPICKER_LABEL_VALUE_MAP_HOURS_24, TIMEPICKER_LABEL_VALUE_MAP_MINUTES, TIMEPICKER_VALUE_LABEL_MAP_MINUTES, TIMEPICKER_LABEL_VALUE_MAP_MERIDIEM, TIMEPICKER_VALUE_LABEL_MAP_MERIDIEM, TIME_VALUE_INTERVAL_MAP };